export interface ParsedErrorMessage {
  title: string
  description?: string
}

const DEFAULT_ERROR_MESSAGE = 'Ocorreu um erro ao processar sua solicitação'

/**
 * Parses a Bifrost error message into title and optional description.
 * Simply returns the message as title, without any complex parsing logic.
 */
export function parseErrorMessage(message: string): ParsedErrorMessage {
  if (!message || !message.trim()) {
    return { title: DEFAULT_ERROR_MESSAGE }
  }

  return { title: message.trim() }
}
